import { render, staticRenderFns } from "./IDCreate.vue?vue&type=template&id=125342bc"
import script from "./IDCreate.vue?vue&type=script&lang=js"
export * from "./IDCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports